export default {
  networkText: {
    timeOut: 'Your active session has timeout. Request you re-login.',
    unableToProcess: 'Sorry! We are unable to process your request. Please re-try after sometime.',
  },
};
